import "./Emenities.scss";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { paths } from "../../../utils/paths";
import AminitiesCard from "./EminitiesCard";
import { Autoplay, FreeMode } from "swiper/modules";

const Emenities = ({ dataList, title }) => {
  const navigate = useNavigate();

  const [heightList, setHeightList] = useState([]);

  return (
    <Fragment>
      <section className="testimonial_slider_sec p_t">
        <div className="content_wrap">
          <h2 className="gold">
            {title &&
              title
                ?.split("")
                .map((char, k) => (
                  <motion.span
                    initial={{ translateX: 24, opacity: 0 }}
                    whileInView={{ translateX: 0, opacity: 1 }}
                    transition={{
                      duration: 0.4,
                      ease: "easeInOut",
                      delay: 0.02 * k,
                    }}
                    key={k}
                  >
                    {char}
                  </motion.span>
                ))
                .concat("")}
          </h2>
        </div>
      </section>

      <section className="amenities_slider_sec">
        {dataList?.length > 0 && (
          <div className="tri_info_slider_wrap">
            <Swiper
              loop={true}
              slidesPerView={4}
              spaceBetween={24}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
              }}
              speed={3000}
              freeMode={true}
              modules={[Autoplay, FreeMode]}
              breakpoints={{
                1400: {
                  slidesPerView: 4,
                },
                900: {
                  slidesPerView: 3,
                },
                600: {
                  slidesPerView: 2,
                },
                10: {
                  slidesPerView: 1,
                },
              }}
            >
              {dataList?.map((data, l) => {
                return (
                  <SwiperSlide key={data?._id}>
                    <AminitiesCard
                      data={data}
                      setHeightList={setHeightList}
                      h={Math.max(...heightList)}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        )}
        <div className="content_wrap">
          <div className="btn_line">
            <button
              type="button"
              className="primary_btn"
              onClick={() => navigate(paths.AMENITIES)}
            >
              <span>View more Amenities</span>
            </button>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Emenities;
